/*global myModal, localisationSurveyDelay, analyticEventTracker, myCookie */

const localisationSurveyModalProps = {
    modalWindowClass: 'bg-black-04 survey-modal',
    closeOutside: true,
    onlyClose: true,
    noHeader: true
};

const cookieName = 'dch-lsm'; // lsm - localisation survey modal

const localisationSurvey = {
    init: function() {
        if (!myCookie.getCookie(cookieName)) {
            const localisationSurvey = $('.localisation-survey');
            if (localisationSurvey.length) {
                const delay = typeof(localisationSurveyDelay) === 'undefined' ? 0 : localisationSurveyDelay;

                setTimeout(() => {
                    localisationSurvey.removeClass('hide');
                    this.bindEvents();
                    this.checkModals();
                }, delay);
            }
        }
    },
    bindEvents: function() {
        $(document)
            .on('click', '.localisation-survey #close-survey', this.closeSurvey)
            .on('click', '.localisation-survey #open-survey', this.openSurvey)
            .on('click', '.localisation-survey-modal__option', this.selectOption)
            .on('click', '.localisation-survey-modal__buttons .back', this.goBack)
            .on('click', '.localisation-survey-modal__buttons .next', this.goNext)
            .on('click', '.localisation-survey-modal #finish-survey, .localisation-survey-modal__close', this.finishSurvey);
    },
    checkModals: function() {
        setInterval(() => {
            if ($('body').hasClass('modal-open') || $('body').hasClass('menu-opened')) {
                $('.localisation-survey').addClass('hide');
            }

            $(document).on('click', function(e) {
                if ($('#localisationSurvey').hasClass('show') && !$(e.target).closest('.localisation-survey-modal').length) {
                    $('.localisation-survey-modal__close').trigger('click');
                }
            });
        }, 500);
    },
    closeSurvey: function(e) {
        e.preventDefault();

        $('.localisation-survey').remove();
        myCookie.setCookie(cookieName, '1', 30);

        localisationSurvey.triggerRateUsModal();
    },
    openSurvey: function(e) {
        e.preventDefault();

        $('.localisation-survey').remove();
        myModal.openStaticModal('localisationSurvey', localisationSurveyModalProps);
    },
    selectOption: function(e) {
        e.preventDefault();

        const that = $(this);
        const currentPart = that.closest('.localisation-survey-modal__questions');

        const options = currentPart.find('.localisation-survey-modal__option');
        const error = currentPart.find('.localisation-survey-modal__error');
        const optionInput = options.find('input');

        options.removeClass('active');
        optionInput.prop('checked', false);
        currentPart.find('.localisation-survey-modal__other').addClass('hide');
        error.addClass('hide');

        that.addClass('active');
        that.find('input').prop('checked', true);

        const nextTextarea = that.next('.localisation-survey-modal__other');

        if (nextTextarea.length) {
            nextTextarea.removeClass('hide');
            nextTextarea.find('textarea').removeClass('error');
        }
    },
    goBack: function(e) {
        e.preventDefault();

        const currentPart = $('.localisation-survey-modal__questions:not(.hide)');
        const prevPart = currentPart.prev('.localisation-survey-modal__questions');

        if (prevPart.length) {
            currentPart.addClass('hide');
            prevPart.removeClass('hide');

            const currentStep = $('.localisation-survey-modal__steps .active');
            currentStep.removeClass('active');
            currentStep.prev().removeClass('disabled').addClass('active');
        }
    },
    goNext: function(e) {
        e.preventDefault();

        const modal = $('.localisation-survey-modal:visible');
        const currentPart = modal.find('.localisation-survey-modal__questions:not(.hide)');
        const activeOption = currentPart.find('.localisation-survey-modal__option.active');
        const otherSection = activeOption.next('.localisation-survey-modal__other');
        const textarea = otherSection.find('textarea');
        const steps = modal.find('.localisation-survey-modal__steps');
        const errorMsg = currentPart.find('.localisation-survey-modal__error');

        if (!activeOption.length || (otherSection.length && textarea.val().trim() === '')) {
            errorMsg.removeClass('hide');
            textarea.addClass('error');
            return;
        }

        errorMsg.addClass('hide');

        const nextPart = currentPart.next('.localisation-survey-modal__questions');

        if (nextPart.length) {
            currentPart.addClass('hide');
            nextPart.removeClass('hide');

            const currentStep = steps.find('.active');
            currentStep.removeClass('active').addClass('disabled');
            currentStep.next().removeClass('disabled').addClass('active');
        } else {
            currentPart.addClass('hide');
            modal.find('.localisation-survey-modal__buttons').hide();
            modal.find('.localisation-survey-modal__final').removeClass('hide');

            const surveyAnswers = {};

            modal.find('.localisation-survey-modal__questions').each(function(index) {
                const that = $(this);
                const questionText = that.find('.question').text().trim();
                const selectedOption = that.find('.localisation-survey-modal__option input:checked').next('label');
                const answer = selectedOption.length ? selectedOption.text().trim() : null;
                let explanation = '';

                if (otherSection.length && textarea.val().trim() !== '') {
                    explanation = textarea.val().trim();
                }

                surveyAnswers[`${index + 1}`] = {
                    question: questionText,
                    answer: answer,
                    explanation: explanation
                };
            });

            $.post(_d.url.submitLocalisationSurvey, {
                surveyData: JSON.stringify(surveyAnswers),
                page: _d.page,
                language: _d.s.language
            }, function(response) {
                if (!response.error) {
                    const eventMapping = {
                        'search-index': 'Lang_Survey_search_Submitted',
                        'booking-index': 'Lang_Survey_offer_Submitted',
                        'reservation-show': 'Lang_Survey_confirmation_Submitted'
                    };

                    if (eventMapping[_d.page]) {
                        analyticEventTracker.trackEvent({
                            eventName: eventMapping[_d.page],
                            attributes: { 'attributePageSource': _d.page }
                        });
                    }
                }
            }, 'json');
        }
    },
    finishSurvey: function(e) {
        e.preventDefault();

        $('.modal.survey-modal').hide();
        $('#localisationSurvey, .modal-backdrop').remove();
        $('body').removeClass('modal-open');

        localisationSurvey.triggerRateUsModal();
    },
    triggerRateUsModal: function() {
        if (_d.page === 'reservation-show' && $('#rateUsModal').length && !myCookie.getCookie('review-' + btoa(_d.rn))) {
            setTimeout(function() {
                myModal.openStaticModal('rateUsModal', {
                    closeOutside: true
                });

                dataLayer.push({
                    'event': 'rateUsImpression'
                });
            }, 1000);
        }
    }
};
